module.exports = {"id":"183346","name":"Fabian Frei","rating":"76","photo":"./data/images/photos/0/183346.png","club":{"name":"FC Bâle","logo":"./data/images/clubs/FCBale.png"},"positions":["MC","MDC","MOC","DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianFrei0.json
// module id = 1327
// module chunks = 0